import { useEffect, useState } from "react";
import { Award as AwardIcon } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { PageHero } from "@/components/site/PageHero";

export default function Premios() {
  const [awards, setAwards] = useState([]);
  useEffect(() => { api.get("/awards").then((r) => setAwards(r.data)); }, []);
  const star = awards.find((a) => a.image_url) || awards[0];
  const rest = awards.filter((a) => a !== star);

  return (
    <div data-testid="premios-page">
      <PageHero testid="premios-hero" eyebrow="Premios y logros" title="Genética en convenio con Cabaña Tres Cruces y Cabaña Doña Evangelina" image={fileUrl(star?.image_url)} />
      {star && (
        <section className="container-fv py-20 sm:py-28 grid gap-12 lg:grid-cols-12 items-center" data-testid="premios-highlight">
          <div className="lg:col-span-7 grid grid-cols-2 gap-4" data-testid="premios-highlight-images">
            {[star.image_url, ...(star.extra_images || [])].filter(Boolean).slice(0, 2).map((u, i) => (
              <img key={u} src={fileUrl(u)} alt={star.title} className={`w-full aspect-[3/4] object-cover ${i ? "mt-10" : ""} ${star.extra_images?.length ? "" : "col-span-2 aspect-[3/2]"}`} />
            ))}
          </div>
          <div className="lg:col-span-5">
            <span className="f-display text-7xl sm:text-8xl text-[#C5A059]/70 leading-none">{star.year}</span>
            <h2 className="f-display mt-4 text-3xl sm:text-4xl">{star.title}</h2>
            <p className="mt-2 eyebrow">{star.event}</p>
            <p className="mt-6 text-[#5C635E] leading-relaxed whitespace-pre-line" data-testid="premios-highlight-description">{star.description}</p>
            {star.video_url && (
              <video src={fileUrl(star.video_url)} controls playsInline preload="metadata" poster={fileUrl(star.extra_images?.[0])} data-testid="premios-highlight-video" className="mt-8 w-full max-w-xs aspect-[9/16] bg-black object-cover" />
            )}
          </div>
        </section>
      )}
      <section className="bg-[#1D3324] py-20 sm:py-24 text-stone-100 relative grain">
        <div className="container-fv relative">
          <p className="eyebrow !text-[#C5A059]">Palmarés</p>
          <h2 className="f-display mt-3 text-3xl sm:text-4xl">Todas las distinciones</h2>
          <ul className="mt-12 divide-y divide-white/10 border-y border-white/10" data-testid="premios-list">
            {awards.length === 0 && <li className="py-6 text-stone-400">Próximamente.</li>}
            {[star, ...rest].filter(Boolean).map((a) => (
              <li key={a.id} data-testid={`premio-item-${a.id}`} className="grid grid-cols-12 items-center gap-4 py-6 transition-colors hover:bg-white/5">
                <span className="col-span-3 sm:col-span-2 f-display text-3xl text-[#C5A059]">{a.year}</span>
                <div className="col-span-9 sm:col-span-8">
                  <p className="f-display text-xl">{a.title}</p>
                  <p className="text-sm text-stone-300/80">{a.event}</p>
                </div>
                <span className="hidden sm:flex col-span-2 justify-end">
                  {a.image_url ? <img src={fileUrl(a.image_url)} alt="" className="h-14 w-20 object-cover" /> : <AwardIcon className="text-[#C5A059]" />}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
